<template>

  <div :class="{inbox: !isMobile().any}">
    <div class="list-field">
      <div class="null-letters" v-if="snippetLetters.length === 0">

        {{ $t('inbox.message.noletters')}}
      </div>
      <div class="letter-list" v-else>
        <ul class="list-group" v-if="isMobile().any">
          <li class="list-group-item" v-for="letter in snippetLetters" :key="letter.id"><router-link :to="{name: 'show-letter', params: {id: letter.id}}">{{ letter.title }}</router-link></li>
        </ul>
        <ul class="list-group" v-else>
          <button type="button" class="list-group-item" v-for="letter in snippetLetters" :key="letter.id" @click="selectLetter(letter.id)">
            {{ letter.title }}
            <button type="button" name="button" @click="deleteLetter(letter.id)" class="btn-delete">x</button>
          </button>
        </ul>
      </div>
    </div>

    <div class="letter-field" v-if="!isMobile().any">
      <div v-if="selectedLetter !== null">
        <Letter :selectedLetter="selectedLetter" />
      </div>
    </div>

  </div>

</template>
<script>
import Letter from '@/components/Letter.vue'
import isMobile from 'ismobilejs'
import firebase from 'firebase'

export default {
  name: 'inbox',
  components: {
    Letter
  },
  data() {
    return {
      db: null,
      isMobile,
      selectedLetter: null,
      letters: [],
      snippetLetters: [],
      user: null
    }
  },
  methods: {
    selectLetter(id){
      let filteredLetter = this.letters.filter(e => e.id === id);
      if (filteredLetter.length !== 0){
        this.selectedLetter = filteredLetter[0];
      }else{
        this.db.collection('letters').doc(id).get().then((res)=>{
          let data = res.data();
          data.id = res.id;
          this.letters.push(data);
          this.selectedLetter = data;
        });
      }
    },
    deleteLetter(id){
      const user = this.user;
      const vue = this;
      // lettersコレクションから削除する
      this.db.collection('letters').doc(id).delete().then(function() {
        // users.uid.lettersから削除する
        vue.db.collection('users').doc(user.uid).collection('letters').doc(id).delete().then(function() {
          console.log("Document successfully deleted!");
        }).catch(function(error) {
          console.error("Error removing document: ", error);
        });
      }).catch(function(error) {
          console.error("Error removing document: ", error);
      });
    }
  },
  beforeMount() {
    this.db = firebase.firestore();
    let now = new Date();
    let vue = this;
    firebase.auth().onAuthStateChanged(user=>{
      if (user){
        vue.db.collection('users').doc(user.uid).collection('letters').orderBy('received_date', 'asc').endAt(now).get().then((res)=>{
          res.forEach((doc) => {
            let letter = doc.data();
            letter.id = doc.id;
            this.snippetLetters.push(letter);
          });
        });
        vue.user = user;
      }
    });
  }
}
</script>
<style scoped>
/* @media (max-width: 767.98px){
}
@media (min-width: 767.98px){ */
  .inbox {
    display: grid;
    grid-template-columns: 30vw 70vw;
    height: 80vh;
  }
/* } */

.null-letters {
  background: linear-gradient(to right, #4facfe 0%, #00f2fe 100%);
  padding: 20px;
}

.btn-delete {
  border-style: solid;
  border-width: 1px;
  float: right;
  background-color: white;
}

/* button {
  background: rgb(14, 188, 235);
} */
</style>
